var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagKazakhstan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1691_41536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.783 12.1304H5.21777C5.21777 13.0669 6.03345 13.826 6.96987 13.826H6.91343C6.91343 14.7625 7.67257 15.5217 8.60909 15.5217C8.60909 16.4582 9.36823 17.2173 10.3047 17.2173H13.6961C14.6326 17.2173 15.3917 16.4582 15.3917 15.5217C16.3282 15.5217 17.0874 14.7625 17.0874 13.826H17.0309C17.9673 13.826 18.783 13.0669 18.783 12.1304Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.696 9.91309C16.696 12.5064 14.5937 14.6087 12.0003 14.6087C9.40698 14.6087 7.30469 12.5064 7.30469 9.91309",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5864 9.91311L14.1208 10.6025L14.9012 12.0219L13.3098 11.7174L13.1082 13.325L11.9997 12.1426L10.8912 13.325L10.6896 11.7174L9.09821 12.0218L9.87859 10.6025L8.41309 9.91311L9.87863 9.22377L9.09821 7.80444L10.6896 8.10885L10.8913 6.50122L11.9997 7.68364L13.1082 6.50122L13.3098 8.10885L14.9013 7.80444L14.1209 9.22381L15.5864 9.91311Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1691_41536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagKazakhstan);
export default __webpack_public_path__ + "static/media/flag-kazakhstan.f08d05a898dce3eb9269fe8272d09060.svg";
export { ForwardRef as ReactComponent };